"use client"
import React, { useEffect, useState } from 'react';
import "../auth.css"
import {
  Box,
  Typography,
  Stack,
  TextField,
  Button,
} from "@mui/material";
import IconButton from '@mui/material/IconButton';
//import { fetchAllSites,resetPassword } from '@/utils/apis/resetPassword/resetPassword';
import { SHA512 } from 'crypto-js';
//import Loading from '@/app/loading';
import SuccessPage from './SuccessPage';
import Footer from '../forgot-password/Footer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getMethod, postMethod } from '../../../services/apiService';
import Loading from '../../loading';

const EnterNewPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const uk = searchParams.get('uk');
  const [successMail, setSuccessMail] = useState(false);
  const [successMessage, setSuccessMessage] = useState('SucceSS');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewPasswordMatch, setShowNewPasswordMatch] = useState(false);
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  // const router = useRouter()
  const [errorMsg, setErrorMsg] = useState('');
  const [uniqueKey, setUniqueKey] = useState<string | number>('');
  const [userId, setUserId] = useState('');


  const handleShowNewPassword = () => {
    setShowNewPassword((prev) => !prev);
  };

  const handleShowNewPasswordMatch = () => {
    setShowNewPasswordMatch((prev) => !prev);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
    setErrorMsg('');
  };

  const [linkExpired, setLinkExpired] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);


  useEffect(() => {
    showIsLoader(true);
    SetLocation();
  }, [])


  useEffect(() => {
    if (uk !== "") {
      validateUniqueToken();
    }
  }, [uk])


  const validateUniqueToken = async () => {
    const resp = await getMethod(`forgot/password/validate/${uk}`);
    if (resp?.data?.code === 200) {
      setUniqueKey(resp?.data?.result?.[0]?.uniquekey);
      setUserId(resp?.data?.result?.[0]?.userid);
      setLinkExpired(false);
      showIsLoader(false);
    } else {
      setLinkExpired(true);
      showIsLoader(false);
    }
  }

  const [path, setPath] = useState('');
  const SetLocation = () => {
    let a = window.location.href;
    let b = a.split('reset-password');
    let path = b[0] + '/forgot-password';
    setPath(path);
  }

  const handleResteLink = () => {
    navigate("/forgot-password");
  }

  const resetPasswordHandle = async (e: React.FormEvent) => {
    e.preventDefault();

    const { newPassword, confirmPassword } = formData;

    if (!newPassword || !confirmPassword) {
      setErrorMsg('Please enter both new password and confirm password.');
    } else if (newPassword !== confirmPassword) {
      setErrorMsg('New password and confirm password do not match.');
    } else {
      let data = {
        userid: userId,
        uniquekey: uniqueKey,
        newpassword: SHA512(formData.newPassword).toString()
      }

      console.log(data)

      const resp = await postMethod("forgot/password/reset", data);
      if (resp?.status === 200) {
        setSuccessMessage(resp?.data?.message)
        setErrorMsg('');
        setFormData({
          newPassword: '',
          confirmPassword: '',
        });
        setSuccessMail(true);
        showIsLoader(true)
        setTimeout(() => {
          setSuccessMail(false);
        }, 4000);
        setShowSuccess(true);
      }
      else
        setErrorMsg(resp.data.message);
    }
  };
  const [isLoader, showIsLoader] = useState(true)

  return (
    <Box className='auth-banner' sx={{ position: 'relative' }}>
      {/* <Loading/> */}
      {!showSuccess && <Box>
        {isLoader ? <Loading /> : linkExpired ?
          <Box>
            <Box className="LinkExpireBox" sx={{
              textAlign: 'center',
            }}>
              <img
                src={"expireLinkImg.svg"}
                alt="expire"
                style={{ cursor: "pointer", marginBottom: '24px' }}
              />

              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 700,
                    fontSize: "24px",
                    lineHeight: '29.05px',
                    color: '#E2E3E3',
                    marginTop: '10px'
                  }}
                >
                  Reset Password Link Expired
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: "16px",
                    lineHeight: '19.36px',
                    color: '#B4B7B8',
                    marginTop: '19px'
                  }}
                >
                  The reset password link you have clicked has expired. For security reasons, reset password links are only valid for a 10 minute.
                </Typography>

                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: '17.94px',
                    color: '#E2E3E3',
                    marginTop: '24px',
                    padding: '0px 100px'
                  }}
                >
                  To access your account, please request a new reset password link by clicking the button below.
                </Typography>
                <Button onClick={handleResteLink} type="submit" variant="contained" sx={{ padding: '12px 16px', mb: '24px', fontSize: '14px', fontWeight: 500, marginTop: '28px' }} className='auth-btn'>
                  Request New Password Reset Link
                </Button>
              </Box>
            </Box>
            <Box sx={{ marginTop: '14%', textAlign: 'center' }}>

              <Typography
                sx={{
                  fontFamily: 'Inter',
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: '16.94px',
                  color: '#B4B7B8',
                  marginLeft: '10px'
                }}
              >
                If you continue to experience issues, please contact our support team for assistance.
              </Typography>
              <div>
                <span className='supportText' style={{ fontFamily: 'Inter', color: '#B4B7B8' }}>Support Email: </span><span className='supportText'>support@soterixsystems.com</span> <span className='supportText' style={{ fontFamily: 'Inter', color: '#B4B7B8' }}>Phone: </span><span className='supportText'>1-800-123-4567</span>
              </div>
            </Box>
          </Box>
          :
          <Box className='login-box'>
            {isLoader ? <Loading /> : <Box
              sx={{
                textAlign: 'center',
              }}
            >
              <img
                src={"logo.svg"}
                alt="logo"
                style={{ cursor: "pointer", marginBottom: '24px' }}
              />

              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: "24px",
                    mb: '24px',
                  }}
                >
                  Reset Password
                </Typography>

                <form onSubmit={resetPasswordHandle}>
                  <Typography
                    sx={{
                      mb: '24px',
                      fontSize: '14px',
                      textAlign: 'center',
                      color: '#FB462E'
                    }}
                  >
                    {errorMsg}
                  </Typography>

                  <Stack>
                    <TextField
                      variant="outlined"
                      placeholder="Enter New Password"
                      className="inputt"
                      type={showNewPassword ? 'text' : 'password'}
                      value={formData.newPassword}
                      onChange={handleChange}
                      name='newPassword'
                      InputProps={{
                        endAdornment: formData.newPassword && (
                          <IconButton
                            onClick={handleShowNewPassword}
                            sx={{ color: '#FFFFFF', right: '10px' }}
                          >
                            {showNewPassword ? <img
                              src={"closed-eye.svg"}
                              alt="Icon"
                            />
                              :
                              <img
                                src={"open-eye.svg"}
                                alt="Icon"
                              />}
                          </IconButton>
                        ),
                        sx: {
                          color: '#E2E3E3',
                          '& fieldset': {
                            border: '1px solid #313838',
                          },
                          '& input::placeholder': {
                            color: '#B4B7B8',
                          },
                          padding: '0px 15px',
                          borderRadius: '8px',
                          fontSize: '16px',
                          mb: '24px'
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": {
                            borderColor: '#313838'
                          }
                        }
                      }}
                      error={errorMsg !== ''}
                    />
                    <TextField
                      variant="outlined"
                      placeholder="Re-Enter New Password"
                      className="inputt"
                      type={showNewPasswordMatch ? 'text' : 'password'}
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      name="confirmPassword"
                      error={errorMsg !== ''}
                      InputProps={{
                        endAdornment: formData.confirmPassword && (
                          <IconButton
                            onClick={handleShowNewPasswordMatch}
                            sx={{ color: '#FFFFFF', right: '10px' }}
                          >
                            {showNewPasswordMatch ?
                              <img
                                src={"closed-eye.svg"}
                                alt="Icon"
                              />
                              :
                              <img
                                src={"open-eye.svg"}
                                alt="Icon"
                              />}
                          </IconButton>
                        ),
                        sx: {
                          color: '#E2E3E3',
                          '& fieldset': {
                            border: '1px solid #313838',
                          },
                          '& input::placeholder': {
                            color: '#B4B7B8',
                          },
                          padding: '0px 15px',
                          borderRadius: '8px',
                          fontSize: '16px',
                          mb: '24px'
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": {
                            borderColor: '#313838'
                          }
                        }
                      }}
                    />

                    <Button type="submit" variant="contained" sx={{ padding: '12px 16px', mb: '24px', fontSize: '14px', fontWeight: 500 }} className='auth-btn'>
                      Reset Password
                    </Button>
                  </Stack>
                </form>
              </Box>
              <Footer />

            </Box>}
            {
              successMail && <div className='successMsg'>
                <img
                  src={"success.svg"}
                  alt="email"
                  style={{ marginBottom: '18px', margin: '0px' }}
                />
                <Box sx={{ marginRight: '20px' }}>
                  <Typography>Success</Typography>
                  <Typography sx={{
                    fontSize: '12px',
                    fontWeight: 400,
                    lineHeight: '14.52px',
                  }}>{successMessage}</Typography>
                </Box>

              </div>
            }

          </Box>}
      </Box>}
      {
        showSuccess && <SuccessPage />
      }
    </Box >


  );
};

export default EnterNewPassword;